export default __webpack_public_path__ + "static/media/Lamborghini_Inside.9640f8e6.jpg";